import AuthService from 'lib/auth/AuthService';
import { createGuestIdentityService } from './GuestIdentityService.impl';

export const myGuestIdentityService = createGuestIdentityService({
  isSignedIn: () => AuthService.isAuthenticated()
});
